/*!
 * Cross-tab shared state.
 *
 * Values in here are shared across screens where it makes sense for
 * a single input to drive multiple views. Currently: a graduate's
 * current salary and student-loan plan are shared between
 * `LoanModeller` and `TakeHome` — they are the same real-world facts,
 * so editing one edits the other.
 *
 * Pre-uni inputs are NOT shared here — they describe a hypothetical
 * future scenario, distinct from the user's current-day facts.
 *
 * Using Svelte 5's module-level runes ($state) so any component
 * importing `graduate` sees the same reactive object.
 */

export const graduate = $state({
  salary: 35000,
  planKey: "plan5",
  loanBalance: 30000,
  currentAge: 22,

  // Populated by the Uni tab whenever its balance-at-graduation
  // calculation runs. Loan modeller reads this to show a "your Uni
  // scenario projects £X; adopt it?" nudge when the two disagree.
  uniProjectedBalance: null,

  // Projection assumptions — shared across Uni, Loan modeller, Pension,
  // Dashboard so the same trajectory shows the same numbers everywhere.
  // Stored as percentages (3 = 3%) to match the UI convention.
  salaryGrowthPct: 3,
  rpiMarchPct: 3.6,
  bankRatePct: 4.25,

  // Pension setup — shared between Pension screen and Loan modeller so
  // the overpayment tool can flag when the user hasn't maxed their
  // employer match yet.
  pensionMethod: "salarySacrifice",
  pensionEmployeePct: 5,
  pensionEmployerBasePct: 3,
  pensionEmployerMatchRatio: 1.0,
  pensionEmployerMatchCapPct: 5,
});
